import _slicedToArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["animated"];
import { useRef, useState, useCallback, useMemo } from 'react';
import { useControlledState, usePreviousValue } from 'ariakit-react-utils/hooks';
/**
 * Provides state for the `Disclosure` components.
 * @example
 * ```jsx
 * const disclosure = useDisclosureState();
 * <Disclosure state={disclosure}>Disclosure</Disclosure>
 * <DisclosureContent state={disclosure}>Content</DisclosureContent>
 * ```
 */

function useDisclosureState(_temp) {
  var _props$defaultOpen;

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$animated = _ref.animated,
      animated = _ref$animated === void 0 ? false : _ref$animated,
      props = _objectWithoutProperties(_ref, _excluded);

  var disclosureRef = useRef(null);

  var _useControlledState = useControlledState((_props$defaultOpen = props.defaultOpen) !== null && _props$defaultOpen !== void 0 ? _props$defaultOpen : false, props.open, props.setOpen),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      open = _useControlledState2[0],
      setOpen = _useControlledState2[1];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      contentElement = _useState2[0],
      setContentElement = _useState2[1];

  var _useState3 = useState(!!animated && open),
      _useState4 = _slicedToArray(_useState3, 2),
      animating = _useState4[0],
      setAnimating = _useState4[1];

  var prevOpen = usePreviousValue(open);
  var mounted = open || animating;

  if (animated && !animating && prevOpen !== open) {
    setAnimating(true);
  }

  var show = useCallback(function () {
    return setOpen(true);
  }, [setOpen]);
  var hide = useCallback(function () {
    return setOpen(false);
  }, [setOpen]);
  var toggle = useCallback(function () {
    return setOpen(function (v) {
      return !v;
    });
  }, [setOpen]);
  var stopAnimation = useCallback(function () {
    return setAnimating(false);
  }, []);
  var state = useMemo(function () {
    return {
      disclosureRef: disclosureRef,
      open: open,
      mounted: mounted,
      animated: animated,
      animating: animating,
      contentElement: contentElement,
      setContentElement: setContentElement,
      setOpen: setOpen,
      show: show,
      hide: hide,
      toggle: toggle,
      stopAnimation: stopAnimation
    };
  }, [open, mounted, animated, animating, contentElement, setContentElement, setOpen, show, hide, toggle, stopAnimation]);
  return state;
}

export { useDisclosureState };